import { useState, useEffect } from 'react';
import useHttp from 'hooks/useHttp';

const useChatbotSession = (apiUrl, initialGreeting) => {
  const [messages, setMessages] = useState([{ role: 'assistant', content: initialGreeting }]);
  const { data, loading, error, sendRequest, clearData } = useHttp();

  const getErrorMessage = (error) => {
  if (!error) {
     return 'Sorry, something went wrong. Please try again.';
  }
  const status = error.response?.status;
  if (status === 503) {
    return 'The service is currently unavailable. Please try again later.';
  }
  if (status === 403) {
    return 'You are not authorized to ask live employee-data questions.';
  }
  if (status === 504) {
    return 'The chatbot took too long to respond. Please try a shorter question.';
  }
  if (status === 500) {
    return `Oops! I ran into a problem on my end and couldn't complete that request. Please contact support for help.`;
  }
  if (error.code === 'ERR_NETWORK') {
    return `I can't reach the server right now. It seems the connection is unavailable. Please check your network and try again.`;
  }

  return error.message || 'Sorry, something went wrong. Please try again.';
};

  useEffect(() => {
    if (error) {
      const errorMessage = getErrorMessage(error);
      setMessages(prev => [
        ...prev,
        { role: 'assistant', content: errorMessage }
      ]);
      clearData();
    }

    if (data) {
      setMessages(prev => [...prev, {
        role: 'assistant',
        content: data.content,
        sources: data.sources || [],
      }]);
      clearData();
    }
  }, [data, error, clearData]);

  const sendMessage = async (input) => {
    const userMessage = { role: 'user', content: input };
    setMessages(prev => [...prev, userMessage]);

    const history = [...messages, userMessage].map(message => ({
      role: message.role,
      content: message.content
    }));

    await sendRequest({
      url: apiUrl,
      method: 'POST',
      data: { question: input, chatHistory: history }
    });
  };

  return { messages, sendMessage, loading };
}

export default useChatbotSession;
